import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"
import Dropzone from "dropzone"

export default class extends Controller {
  static targets = ["clickable"]

  connect() {
    Dropzone.autoDiscover = false

    this.dropzone = new Dropzone(this.element, {
      paramName: "vendor[photo]",
      url: this.element.dataset.url || this.element.action,
      maxFilesize: Number(this.element.dataset.maxFilesize || 10),
      acceptedFiles: this.element.dataset.acceptedFiles,
      addRemoveLinks: this.element.dataset.addRemoveLinks === "true",
      clickable: this.clickableTarget,
      autoProcessQueue: true,
      previewsContainer: false,
      headers: { Accept: "text/vnd.turbo-stream.html, text/html, application/xhtml+xml" },
      dictFileTooBig: this.element.dataset.dictFileTooBig,
      dictInvalidFileType: this.element.dataset.dictInvalidFileType,
      dictResponseError: this.element.dataset.dictResponseError
    })

    this.dropzone.on("addedfile", () => this.showError(""))

    // Dropzone uploads over its own XHR, so Turbo never sees the response.
    // Apply the turbo-stream ourselves so the photo grid refreshes.
    this.dropzone.on("success", (_file, response) => {
      if (typeof response === "string" && response.includes("<turbo-stream")) {
        Turbo.renderStreamMessage(response)
      }
    })

    // Rejections land here: in the browser (too big, wrong type) as a plain
    // message, or from the server (422) as a turbo-stream carrying the form's
    // own errors. Without this they fail silently.
    this.dropzone.on("error", (file, message, xhr) => {
      this.dropzone.removeFile(file)

      if (typeof message === "string" && message.includes("<turbo-stream")) {
        Turbo.renderStreamMessage(message)
      } else {
        this.showError(xhr ? this.element.dataset.dictResponseError : message)
      }
    })
  }

  // The clickable tile is a div with role="button"; Dropzone only listens for
  // clicks on it, so forward Enter/Space for keyboard users.
  openFilePicker(event) {
    event.preventDefault()
    this.clickableTarget.click()
  }

  showError(message) {
    const element = document.getElementById(this.element.dataset.errorId)
    if (element) element.textContent = message
  }

  disconnect() {
    this.dropzone?.destroy()
    this.dropzone = null
  }
}
